import { useEffect } from "react";
import { env } from './../../../env';

const WebComponent = ({ checkoutParam, paymentMethodAppearance, isCustomCallback, setIsError, setIsSuccess, setPaymentResult }) => {
    // useEffect(() => {
    //     let paymentOptionsElement = document.querySelector('payment-options');
    //     if (paymentOptionsElement) {
    //         paymentOptionsElement.paymentMethodAppearance = paymentMethodAppearance;
    //     }
    // }, []);

    useEffect(() => {
        let paymentOptionsElement = document.getElementById('wps-payment-options');
        if (paymentOptionsElement) {
            if (isCustomCallback) {
                paymentOptionsElement.setSecureCallback((result) => {
                    if (result.detail && result.detail.success) {
                        setIsError(false);
                        setIsSuccess(true);
                        setPaymentResult(result.detail.success);
                    }
                    if (result.detail && result.detail.error) {
                        setIsSuccess(false);
                        setIsError(true);
                        setPaymentResult(result.detail.error);
                    }
                });
            } else {
                paymentOptionsElement.addEventListener('wpsPaymentEvent', (event) => {
                    if (event.detail && event.detail.success) {
                        setIsError(false);
                        setIsSuccess(true);
                        setPaymentResult(event.detail.success);
                    }
                    if (event.detail && event.detail.error) {
                        setIsSuccess(false);
                        setIsError(true);
                        setPaymentResult(event.detail.error);
                    }
                });
            }
        }
    }, []);

    const webComponentProps = {
        paymentToken: checkoutParam.paymentToken,
        paymentReference: checkoutParam.paymentReference,
        appId: checkoutParam.appId,
        region: checkoutParam.region,
        intentType: checkoutParam.intentType,
        locale: checkoutParam.locale,
        currency: checkoutParam.presentmentCurrency,
        timestamp: checkoutParam.timestamp,
        amount: checkoutParam.amount,
        paypalFakeNonce: checkoutParam.payPalFakeNonce,
        captchaRetryAttempt: checkoutParam.captchaRetryAttempt,
        captchaSiteKey: checkoutParam.captchaSiteKey,
        captchaTestDescription: checkoutParam.captchaTestDescription,
        declineRateLimit: checkoutParam.declineRateLimit,
        buttonId: checkoutParam.buttonId,
        confirm: checkoutParam.confirm
    }
    if (checkoutParam.isCaptchaTestMode === "Yes") {
        webComponentProps.isCaptchaTestMode = checkoutParam.isCaptchaTestMode;
    }
    if (checkoutParam.isPayPalTestMode === "Yes") {
        webComponentProps.isPayPalTestMode = checkoutParam.isPayPalTestMode;
    }
    if (process.env.REACT_APP_WEB_COMPONENT_DISABLE_CAPTCHA === "Yes" || checkoutParam.disableCaptcha === "Yes") {
        webComponentProps.disableCaptcha = "Yes";
    }
    if (checkoutParam.apiVersion === "2") {
        webComponentProps.paymentConfig = JSON.stringify(checkoutParam.paymentConfig);
    }

    return <>
        <payment-options id="wps-payment-options" {...webComponentProps} />
    </>

}

export default WebComponent;